import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { FormulaToken } from '../formula';
import { formulaText, validateTypedFormula } from '../formula-typing';

@Component({
  selector: 'cipo-formula-status',
  imports: [FlexLayoutModule, MatIconModule, TranslateModule],
  template: `
    @if (tokens().length) {
      <div fxLayout="column" fxLayoutGap="4px" role="status" data-testid="module-config-field-formula-status">
        <span class="mat-body-2 cipo-text--black-800">{{ text() }}</span>
        @if (error(); as error) {
          <span
            class="mat-caption cipo-text--warn-900"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="4px"
            data-testid="module-config-field-formula-status-error"
            [attr.data-error]="error">
            <mat-icon inline aria-hidden="true">error_outline</mat-icon>
            {{ error | translate }}
          </span>
        } @else {
          <span
            class="mat-caption cipo-text--accent-900"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="4px"
            data-testid="module-config-field-formula-status-valid">
            <mat-icon inline aria-hidden="true">check_circle</mat-icon>
            {{ 'modules.fieldConfig.formula.valid' | translate }}
          </span>
        }
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormulaStatusComponent {
  private readonly translate = inject(TranslateService);

  readonly tokens = input<FormulaToken[]>([]);
  readonly isDateResult = input(false);

  readonly text = computed(() =>
    formulaText(this.tokens(), part => this.translate.instant(`modules.fieldConfig.formula.dateParts.${part}`)),
  );
  readonly error = computed(() => validateTypedFormula(this.tokens(), this.isDateResult()).errors[0]);
}
